import { styled, component } from '../../utils/style';
import { Format, StyleColor } from '../../utils/styles-constants';
import { AuthenticateButton } from '../Authentication/styles';
const aspLoginBackgroundImg = require('../../images/aspLoginBackground.jpg');

export const StyledMultiAppAuthentication = styled()(component.div, 'StyledMultiAppAuthentication') `
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	overflow: auto;
	background-color: ${StyleColor.White};
	background-image: url('${aspLoginBackgroundImg}');
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	display: flex;
	flex-grow: 1;
	justify-content: center;
`;

export const MultiAppAuthenticationContainer = styled()(component.div, 'MultiAppAuthenticationContainer')`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 30px 15px;
`;


export const WebpublicationLogo = styled()(component.div, 'WebpublicationLogo') `
	display: flex;
	justify-content: center;
	padding: 0 30px;

	> svg {
		max-width: 100%;
	}
`;

export const MultiAppAuthenticationTitle = styled()(component.div, 'MultiAppAuthenticationTitle') `
	font-weight: 500;
	margin-bottom: 15px;
`;

export const MultiAppAuthenticationError = styled()(component.div, 'MultiAppAuthenticationError') `
	color: ${StyleColor.Red};
	text-align: center;
	margin-bottom: 15px;
`;

export const MultiAppAuthenticationOptionsWrapper = styled()(component.div, 'MultiAppAuthenticationOptionsWrapper') `
	margin-top: 30px;
	color: ${StyleColor.Grey600};
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;

	@media ${Format.Smartphone} {
		flex-direction: column;
		align-items: center;
	}
`;

export const InputWrapper = styled()(component.div, 'InputWrapper') `
	position: relative;
	margin-bottom: 20px;

	input[type="checkbox"]{
		display : none;
	}

	> div:first-of-type {
		position: absolute;
		width: 22px;
		height: 22px;
		top: 0;
		left: 0;
		background: #eee;
		border: 1px solid #ddd;
		cursor: pointer;
	}

	div:first-of-type:after {
		content: '';
		position: absolute;
		width: 9px;
		height: 5px;
		background: transparent;
		top: 6px;
		left: 5px;
		border: 0;
		transform: rotate(-45deg);
	}

	input[type="checkbox"]:checked + div:first-of-type:after {
		border: 2px solid #333;
		border-top: none;
		border-right: none;
	}

	label {
		position: relative;
		top: 5px;
		margin-left: 35px;
		cursor: pointer;
	}
`;

export const ForgotPasswordLink = styled()(component.a, 'ForgotPasswordLink') `
	color: ${StyleColor.Grey600};
	line-height: 29px;

	@media ${Format.Smartphone} {
		margin-top: 10px;
	}
`;

export const BackToLoginViewBlock = styled()(component.div, 'BackToLoginViewBlock') `
	cursor: pointer;
	text-align: center;
	margin-top: 50px;
	color: ${StyleColor.Grey600};
`;

export const SwitchToDemoViewBlock = styled()(component.div, 'SwitchToDemoViewBlock') `
	width: 100%;
	max-width: 430px;
	padding: 5px;
	box-sizing: border-box;
	margin: 0 0 30px 0;
	text-align: center;
`;

export const SwitchToDemoFormButton = AuthenticateButton.extend`
	border-color: ${StyleColor.Green};
	background-color: ${StyleColor.Green};

	@media (hover: hover) {
		&:hover {
			border-color: ${StyleColor.Green};
			background-color: ${StyleColor.Green};
		}
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/styles.ts